export default "__VITE_ASSET__ec03ee49__"